<template>
  <div class="context">
    <div class="cardheard">
      <div>
        <el-input placeholder="请输入姓名/手机号" v-model="req.parma" />
      </div>
      <el-button type="primary" @click="selectByQuery">查询</el-button>
      <el-button type="primary" @click="clear">清空</el-button>
      <el-button type="primary" @click="modelShow=true">新增</el-button>
    </div>
    <template>
      <el-table v-model="Users" :data="Users" style="width: 100%" height="80%" v-loading="loading">
        <el-table-column type="index" width="50">
        </el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.nickName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>

        <el-table-column label="UID">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column label="当前余额">
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>

        <el-table-column label="地址" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.city }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="300">

          <template slot-scope="scope">
            <el-button type="text" @click="updateUser(scope.row)" size="small">修改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="10000">
          </el-pagination>
        </div>
      </div>


    </template>
    <template>
    </template>

    <div v-if="modelShow">
      <UserUpdateorAdmin :dialogShow="modelShow" ref="userModel" @pushdata="pushdata"  @modelChange="userShowChange" />
    </div>
  </div>
</template>

<script>
import store from '@/store/'
import UserUpdateorAdmin from '../components/userUpdateorAdmin.vue'

export default {
  data() {
    return {
      loading:true,
      req: {
        parma: "",
        pageIndex: 0,
        pageCount: 10
      },
      Users: [],
      modelShow: false
    };
  },
  mounted() {
    this.pushdata();
  },
  methods: {
    reset() {
      this.req.pageIndex=0
      this.req.pageCount=10
    },
    clear(){
      this.req.parma=""
      this.reset()
      this.pushdata()
    },
    selectByQuery() {
      this.req.pageIndex = 0;
      this.pushdata();
    },
    updateUser(row) {
      this.modelShow = true,
        setTimeout(() => {
          this.$refs['userModel'].init(row.id)//用$refs赋值调用子组件的init方法
        }, 500)
    },
    userShowChange(visible){
      this.modelShow=visible
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      }
      else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }
      console.log(this.req);
      this.pushdata();
    },
    pushdata() {
      var that = this;
      that.$axios
        .post("/api/user/showAllByPage", this.req)
        .then(function (response) {
          that.loading=false
          that.Users = response.data.data;
        });
    }
  },
  components: { UserUpdateorAdmin }
}
</script>
<style scoped></style>
